import sanctumoftheburningsouls from 'assets/images/dungeons/SanctumOfTheBurningSouls.jpg';
import abyssofkunwhu from 'assets/images/pve/abyssofkunwhu.jpg';
import aidistrict from 'assets/images/pve/aidistrict.jpg';
import ardashirfort from 'assets/images/pve/ardashirfort.jpg';
import atzelsfortress from 'assets/images/pve/atzelsfortress.jpg';
import blackringcitadelwing1 from 'assets/images/pve/blackringcitadelwing1.jpg';
import blackringcitadelwing2 from 'assets/images/pve/blackringcitadelwing2.jpg';
import blackringcitadelwing3 from 'assets/images/pve/blackringcitadelwing3.jpg';
import caravanraidershideoutnormal from 'assets/images/pve/caravanraidershideoutnormal.jpg';
import caravanraidershideoutunchained from 'assets/images/pve/caravanraidershideoutunchained.jpg';
import chamberoflostdreams from 'assets/images/pve/chamberoflostdreams.jpg';
import coilsofubahkan from 'assets/images/pve/coilsofubahkan.jpg';
import coppiceoftheheart from 'assets/images/pve/coppiceoftheheart.jpg';
import crowsnest from 'assets/images/pve/crowsnest.jpg';
import deadmanshandnormal from 'assets/images/pve/deadmanshandnormal.jpg';
import deadmanshandunchained from 'assets/images/pve/deadmanshandunchained.jpg';
import denofthecrowmen from 'assets/images/pve/denofthecrowmen.jpg';
import forgottenCityNormal from 'assets/images/pve/forgottencitynormal.jpg';
import forgottenCityUnchained from 'assets/images/pve/forgottencityunchained.jpg';
import hallsofeternalfrostnormal from 'assets/images/pve/hallsofeternalfrostnormal.jpg';
import hallsofeternalfrostunchained from 'assets/images/pve/hallsofeternalfrostunchained.jpg';
import houseofcrom from 'assets/images/pve/houseofcrom.jpg';
import isleofironstatues from 'assets/images/pve/isleofironstatues.jpg';
import kangpagoda from 'assets/images/pve/kangpagoda.jpg';
import kyllikkiscrypt from 'assets/images/pve/kyllikkiscrypt.jpg';
import palaceofcetriss from 'assets/images/pve/palaceofcetriss.jpg';
import palaceofyunrau from 'assets/images/pve/palaceofyunrau.jpg';
import pillarsofheaven from 'assets/images/pve/pillarsofheaven.jpg';
import refugeoftheapostate from 'assets/images/pve/refugeoftheapostate.jpg';
import reliquaryofflame from 'assets/images/pve/reliquaryofflame.jpg';
import sepulcherofthewyrm from 'assets/images/pve/sepulcherofthewyrm.jpg';
import theampitheatreofkarutonianormal from 'assets/images/pve/theampitheatreofkarutonianormal.jpg';
import theampitheatreofkarutoniaunchained from 'assets/images/pve/theampitheatreofkarutoniaunchained.jpg';
import thecavernofmalice from 'assets/images/pve/thecavernofmalice.jpg';
import thecelestialnecropolis from 'assets/images/pve/thecelestialnecropolis.jpg';
import theenigmataofyag from 'assets/images/pve/theenigmataofyag.jpg';
import theironTower from 'assets/images/pve/theirontower.jpg';
import thejadedugout from 'assets/images/pve/thejadedugout.jpg';
import thejadecitadelcourtyard from 'assets/images/pve/jadecitadelcourtyard.jpg';
import thelair from 'assets/images/pve/thelair.jpg';
import otherworldlyjunction from 'assets/images/pve/otherworldlyjunction.jpg';
import thescorpioncavenormal from 'assets/images/pve/thescorpioncavenormal.jpg';
import thescorpioncaveunchained from 'assets/images/pve/thescorpioncaveunchained.jpg';
import theslitheringchaos from 'assets/images/pve/theslitheringchaos.jpg';
import thevilenativity from 'assets/images/pve/thevilenativity.jpg';
import templeoferlik from 'assets/images/pve/templeoferlik.jpg';
import tianandistrict from 'assets/images/pve/tianandistrict.jpg';
import thothamonstronghold from 'assets/images/pve/thothamonsstronghold.jpg';
import thothamonstrongholdsecondfloor from 'assets/images/pve/thothamonstrongholdsecondfloor.jpg';
import vortexofthestorm from 'assets/images/pve/vortexofthestorm.jpg';
import yakhmarscave from 'assets/images/pve/yakhmarscave.jpg';
import xibaluku from 'assets/images/pve/xibaluku.jpg';


export const PveIcons: any = {
  2085: sanctumoftheburningsouls,
  6312: abyssofkunwhu,
  6432: aidistrict,
  7030: ardashirfort,
  1085: atzelsfortress,
  3033: caravanraidershideoutnormal,
  3043: caravanraidershideoutunchained,
  3075: coilsofubahkan,
  6122: coppiceoftheheart,
  2024: crowsnest,
  7011: deadmanshandnormal,
  7013: deadmanshandunchained,
  6311: denofthecrowmen,
  6004: forgottenCityNormal,
  6008: forgottenCityUnchained,
  1082: hallsofeternalfrostnormal,
  1081: hallsofeternalfrostunchained,
  1070: houseofcrom,
  7020: isleofironstatues,
  6110: kangpagoda,
  6320: palaceofyunrau,
  6130: pillarsofheaven,
  6213: refugeoftheapostate,
  6120: reliquaryofflame,
  3077: sepulcherofthewyrm,
  1092: theampitheatreofkarutonianormal,
  1094: theampitheatreofkarutoniaunchained,
  6210: thecavernofmalice,
  6211: thecelestialnecropolis,
  6212: theenigmataofyag,
  2029: theironTower,
  6310: thejadedugout,
  3035: thescorpioncavenormal,
  3055: thescorpioncaveunchained,
  3078: theslitheringchaos,
  1071: thevilenativity,
  6433: tianandistrict,
  6121: vortexofthestorm,
  2095: xibaluku,
  1022: kyllikkiscrypt,
  1052: yakhmarscave,
  1084: thelair,
  3034: blackringcitadelwing1,
  3044: blackringcitadelwing2,
  3045: blackringcitadelwing3,
  3032: thothamonstronghold,
  3042: thothamonstrongholdsecondfloor,
  7040: templeoferlik,
  6420: thejadecitadelcourtyard,
  6427: chamberoflostdreams,
  1058: otherworldlyjunction,
  3082: palaceofcetriss,
}